<template>
    <div class="mt-3">
        <companyProfileAchievments :company_page="company_page" class="mb-5" />
        <v-layout row wrap>
            <v-flex xs12 md6>
                <div class="grey-text my-2">{{$t("Контактный телефон")}}</div>
                <inputBase disabled :value="company_page.phone_numbers" />
            </v-flex>
            <v-flex xs12 md6 :class="{'pl-0 mt-4': $vuetify.breakpoint.smAndDown, 'pl-4': $vuetify.breakpoint.mdAndUp}">
                <div class="grey-text my-2">E-mail</div>
                <inputBase disabled :value="company_page.email" />
            </v-flex>
        </v-layout>
        <v-layout wrap row mt-4
                  grid-list-md
        >
            <v-flex v-if="other_active_country || (active_city && active_region) || (other_active_city && other_active_region)" xs12 md6>
                <div class="grey-text my-2">{{ `${$t('Страна')}, ${$t('Город')}, ${$t('Регион')}` }}</div>
                <inputBase disabled :value="set_region" />
            </v-flex>
            <v-flex xs12 md6 :class="{'pl-0 mt-4': $vuetify.breakpoint.smAndDown, 'pl-4': $vuetify.breakpoint.mdAndUp}">
                <div class="grey-text my-2">{{$t("Адрес")}}</div>
                <inputBase disabled :value="company_page.address" />
            </v-flex>
        </v-layout>
        <!-- if admin $route.params-->
        <div>
            <v-layout wrap row mt-4
                      grid-list-md
            >
                <!-- <v-flex v-if='set_group && user_role.company_manage.includes("C")' xs12 md6>
                    <div class="grey-text my-2">{{$t("Группа компаний")}}</div>
                    <inputBase disabled :value="set_group.type" />
                </v-flex> -->
                <v-flex v-if='user_role.company_manage.includes("C")' xs12 md6
                        :class="{'pl-0 mt-4': $vuetify.breakpoint.smAndDown, 'pl-4': $vuetify.breakpoint.mdAndUp && set_group && false}"
                >
                    <div class="grey-text my-2"> {{$t("Ответственное лицо организации")}}</div>
                    <inputBase disabled :value="company_page.users_responsible" />
                </v-flex>
            </v-layout>
            <v-layout wrap row mt-4
                      grid-list-md
            >
                <v-flex xs12 md6>
                    <div class="grey-text my-2">{{$t("Заместитель ответственного лица")}}</div>
                    <inputBase disabled :value="company_page.users_replacement" />
                </v-flex>
                <v-flex xs12 md6 :class="{'pl-0 mt-4': $vuetify.breakpoint.smAndDown, 'pl-4': $vuetify.breakpoint.mdAndUp && !user.external}">
                    <v-layout align-end wrap>
                        <v-flex mr-4 :class="{'pl-0 mt-4': $vuetify.breakpoint.smAndDown, 'pl-4': $vuetify.breakpoint.mdAndUp}"
                                xs12
                                sm5
                        >
                            <div class="grey-text my-2"> {{$t("Количество сотрудников")}}</div>
                            <inputBase disabled :value="company_page.users_count" />
                        </v-flex>
                        <v-flex v-bind="{'text-sm-right': !user.external}" :class="{'mt-4': $vuetify.breakpoint.xs}">
                            <buttonBdWhite @click.native="go_to_org">{{$t("Сотрудники организации")}}</buttonBdWhite>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>
        <v-layout row mt-4>
            <v-flex>
                <div class="grey-text my-2">{{$t("Деятельность организации")}}</div>
                <textareaBase disabled :value="company_page.about" rows="4" />
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import inputBase from '@/components/ui/inputs/base/input';
import textareaBase from '@/components/ui/inputs/base/textarea';
import companyProfileAchievments from '@/components/view_blocks/Company_profile/Company_profile_info/Company_profile_achievments';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapGetters, mapMutations} from 'vuex';

export default {
  components: {
    inputBase,
    textareaBase,
    companyProfileAchievments,
    buttonBdWhite,
  },
  props: {
    company_page: {
      type: Object,
    },
  },
  data() {
    return {
      user_role: {
        user_analytics: '',
        company_manage: [],
      },
    };
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('company_profile/info', [
      'company_info',
      'active_group',
      'active_city',
      'active_region',
    ]),
    organization_employees() {
      return this.user.role_code === 'ADMINISTRATOR' || (this.user_role.user_analytics && this.user.company_name === this.company_page.name);
    },
    company() {
      return Object.keys(this.company_page).length || {title: find};
    },
    ...mapGetters('company_profile/', [
      'other_active_country',
      'other_active_region',
      'other_active_city',
      'other_active_group',
    ]),
    groups: {
      get() {
        return this.company_info.groups.filter((x) => {
          return x.selected;
        }).map((y)=> y.name);
      },
    },
    set_region() {
        let region_name = '';

        if (this.other_active_country) {
            region_name += this.other_active_country.text + ', ';
        }
        if (this.$route.params.id && this.other_active_city) {
            region_name =  region_name + this.other_active_city.type + ', ' + this.other_active_region.type;
        } else if (!this.$route.params.id) {
            region_name =  region_name + this.active_city.type + ', ' + this.active_region.type;
        } else {
            region_name = region_name.slice(0, -2);
        }

        return region_name;
    },
    set_group() {
      if (this.$route.params.id ) {
        return this.other_active_group;
      } else {
        return this.active_group;
      }
    },
  },
  mounted() {
    if (localStorage.user != 'undefined') {
      this.REPLACE_USER_PROFILE(JSON.parse(localStorage.getItem('user')));
      this.$set(this.user_role, 'user_analytics', this.user.role.user_analytics.rights.length);
      this.$set(this.user_role, 'company_manage', this.user.role.managment_of_organizations.rights);
    }
  },
  methods: {
    ...mapMutations('users', [
      'SET_ACTIVE_TAB',
    ]),
    ...mapMutations('users/employees', [
      'SET_ORG_FILTER',
    ]),
    ...mapMutations('profile/user', [
      'REPLACE_USER_PROFILE',
    ]),
    go_to_org() {
      let id = this.$route.params.id || this.user.company_id;

      this.SET_ACTIVE_TAB('employees');
      this.$router.push({name: 'users', query: {filter_org: id}});
    },
  },
};
</script>

